import React, { useEffect, useRef, useState } from 'react';
import { Typography, Autocomplete, TextField, Paper, InputAdornment } from '@mui/material';
import { Box } from '@mui/system';
import Grid from '@mui/material/Grid';
import { API, graphqlOperation } from 'aws-amplify';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import VoucherComponent from './VoucherComponent';
import { getpospartydetails } from '../../../graphql';
import LabelIcon from './LabelIcon';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useStateList } from './HandleInvoiceStateProvider';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { useTaxabilityOptions } from './UseTaxabilityOptions';
import { useListGeneralSettingQuery } from '../../../redux/apis/newVoucherSettings.api';

function InvoicePosBasicDetails({ todayDate, moment, params, invoiceLabels, Type }) {
  const {
    setInitialState,
    data,
    setData,

    fromDayDate,

    endDayDate,

    invoiceEntry,

    companyData,
    setCompanyData,

    voucherArr,
    setVoucherArr,

    activeVouchers,

    lastInvoiceDate,

    setRegistrationType,

    setPartyType,
    totNetAmt,
    items,
    setItems,
    firstInvoiceDate,
    nextInvoiceDate,
    generalSettingsFlag,
    setGeneralSettingsFlag
  } = useStateList();
  const {
    allTaxabilityOptions,
    taxabilityOptions,

    compositeTaxabilityForCustomer,
  } = useTaxabilityOptions();
  const billingCurrencyOptions = [
    { label: 'Rupee (₹)', value: '1', sign: '₹', code: 'INR' },
    { label: 'Us Dollar ($)', value: '2', sign: '$', code: 'USD' },
    { label: 'Euro (€)', value: '3', sign: '€', code: 'EUR' },
    { label: 'British Pound (£)', value: '4', sign: '£', code: 'GBP' },
    { label: 'Japanese Yen (¥)', value: '5', sign: '¥', code: 'JPY' },
    { label: 'Australian Dollar (A$)', value: '6', sign: 'A$', code: 'AUD' },
    { label: 'Canadian Dollar (C$)', value: '7', sign: 'C$', code: 'CAD' },
    { label: 'Swiss Franc (Fr.)', value: '8', sign: 'Fr.', code: 'CHF' },
    { label: 'Chinese Yuan (¥)', value: '9', sign: '¥', code: 'CNY' },
    { label: 'Singapore Dollar (S$)', value: '10', sign: 'S$', code: 'SGD' },
    { label: 'Argentine Peso ($)', value: '11', sign: '$', code: 'ARS' },
    { label: 'Bangladeshi Taka (৳)', value: '12', sign: '৳', code: 'BDT' },
    { label: 'Brazilian Real (R$)', value: '13', sign: 'R$', code: 'BRL' },
    { label: 'Chilean Peso ($)', value: '14', sign: '$', code: 'CLP' },
    { label: 'Colombian Peso ($)', value: '15', sign: '$', code: 'COP' },
    { label: 'Czech Koruna (Kč)', value: '16', sign: 'Kč', code: 'CZK' },
    { label: 'Danish Krone (kr)', value: '17', sign: 'kr', code: 'DKK' },
    { label: 'Egyptian Pound (£)', value: '18', sign: '£', code: 'EGP' },
    { label: 'Hong Kong Dollar (HK$)', value: '19', sign: 'HK$', code: 'HKD' },
    { label: 'Hungarian Forint (Ft)', value: '20', sign: 'Ft', code: 'HUF' },
    { label: 'Indonesian Rupiah (Rp)', value: '21', sign: 'Rp', code: 'IDR' },
    { label: 'Israeli Shekel (₪)', value: '22', sign: '₪', code: 'ILS' },
    { label: 'Malaysian Ringgit (RM)', value: '23', sign: 'RM', code: 'MYR' },
    { label: 'Mexican Peso ($)', value: '24', sign: '$', code: 'MXN' },
    {
      label: 'New Zealand Dollar (NZ$)',
      value: '25',
      sign: 'NZ$',
      code: 'NZD',
    },
    { label: 'Norwegian Krone (kr)', value: '26', sign: 'kr', code: 'NOK' },
    { label: 'Pakistani Rupee (₨)', value: '27', sign: '₨', code: 'PKR' },
    { label: 'Peruvian Sol (S/.)', value: '28', sign: 'S/.', code: 'PEN' },
    { label: 'Philippine Peso (₱)', value: '29', sign: '₱', code: 'PHP' },
    { label: 'Polish Zloty (zł)', value: '30', sign: 'zł', code: 'PLN' },
    { label: 'Romanian Leu (lei)', value: '31', sign: 'lei', code: 'RON' },
    { label: 'Russian Ruble (₽)', value: '32', sign: '₽', code: 'RUB' },
    { label: 'Saudi Riyal (﷼)', value: '33', sign: '﷼', code: 'SAR' },
    { label: 'South African Rand (R)', value: '34', sign: 'R', code: 'ZAR' },
    { label: 'South Korean Won (₩)', value: '35', sign: '₩', code: 'KRW' },
    { label: 'Swedish Krona (kr)', value: '36', sign: 'kr', code: 'SEK' },
    { label: 'Thai Baht (฿)', value: '37', sign: '฿', code: 'THB' },
    { label: 'Turkish Lira (₺)', value: '38', sign: '₺', code: 'TRY' },
    { label: 'UAE Dirham (د.إ)', value: '39', sign: 'د.إ', code: 'AED' },
    { label: 'Vietnamese Dong (₫)', value: '40', sign: '₫', code: 'VND' },
  ];

  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [posParties, setPosParties] = useState([]);
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);


  let companyType = getCompany?.relatedcompanydetailsnew?.[0].registrationtype;
  const validateContactNumber = (number) => /^\d{10,15}$/.test(number); 
  
    const { data: generalSettings } = useListGeneralSettingQuery(
        {
          entrytypecd: invoiceLabels.voucherType,
          financialyearid: getCompany.financialyearid,
        },
        {
          refetchOnMountOrArgChange: true,
        }
      );
      const voucherFlag = generalSettings?.find((item) => item.expiredtimestamp === 0)?.nextinvoicenumber;

const handlePartyNumberChange = (e, value) => {
  if (!value?.label) return;

  let sanitizedNumber = value.label.replace(/\D/g, "").slice(0, 15);

  const isValid = validateContactNumber(sanitizedNumber);

  setData((prev) => ({
    ...prev,
    partyContactNumber: sanitizedNumber,
    partyName: value?.partyName || prev.partyName,
    errorStatus: {
      ...prev.errorStatus,
      partyContactNumber: !isValid, 
      partyName: false,
    },
    errorFields: {
      ...prev.errorFields,
      partyContactNumber: isValid ? "" :  "Contact number must have at least 10 digits.",
      partyName: "",
    },
  }));
};



  const handlePartyInputChange = (e, newValue) => {
    if (newValue) {
      getPosPartiesDetails(newValue);
    } else {
      setData((prev) => ({
        ...prev,
        partyContactNumber: '',
        errorStatus: {
          ...prev.errorStatus,
          partyContactNumber: false,
          partyName: false,
        },
        errorFields: {
          ...prev.errorFields,
          partyContactNumber: '',
          partyName: '',
        },
      }));
      getPosPartiesDetails('');
    }
  };
const validateContactTextNumber = (num) => /^\d{10,15}$/.test(num); 

const handleTextPartyNumberChange = (e) => {
  let value = (e.target.value || "").replace(/\D/g, "").slice(0, 15);

  const matchedParty = posParties.find((party) => party.label === value);
  const prevPartyName =
    invoiceEntry?.relatedinvoiceposdetails?.[0]?.relatedposparty?.[0]?.partyname || "";

  setData((prev) => {
    const updatedPartyName =
      matchedParty?.partyName || prev.partyName || prevPartyName || "";

    const isValid = validateContactTextNumber(value);

    return {
      ...prev,
      partyContactNumber: value,
      partyName: updatedPartyName,
      errorStatus: {
        ...prev.errorStatus,
        partyContactNumber: !isValid, 
      },
      errorFields: {
        ...prev.errorFields,
        partyContactNumber: isValid
          ? ""
          : "Contact number must have at least 10 digits.",
      },
    };
  });
};


  async function getCompanyDetails() {
    try {
      if (getCompany !== null) {
        setCompanyData(getCompany);
        setRegistrationType(getCompany?.relatedcompanydetailsnew?.[0].registrationtype);
      }
    } catch (error) {
      console.log(error);
    }
  }
  const handlePartyNameChange = (e) => {
  let value = e.target.value;
  value = value.trimStart();


  if (value.length > 0) {
    value = value
      .split(/\s+/) 
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  setData((prev) => ({
    ...prev,
    partyName: value,
  }));
};

  const handleCurrencyChange = (e, newValue) => {
    if (newValue?.value !== '') {
      getCurrentCurrencyRate(newValue.code);
      setData((prev) => ({
        ...prev,
        currency: newValue,
      }));
    }
  };
  const handleCurrencyRateChange = (e) => {
    let value = e.target.value;
    value = value.replace(/,/g, '');

    if (value === '0-') {
      value = '-0';
    }
    if (value === '-') {
      value = '0';
    }
    if (!/^(-?\d*(?:\.\d*)?)$/.test(value)) {
      return;
    }

    setData((prev) => ({
      ...prev,
      currencyRate: value,
      errorStatus: {
        ...prev.errorStatus,
        currencyRate: value === '' ? true : false,
      },
    }));
  };
  const handleInvoiceDateChange = (e) => {
    const value = e.target.value;
    handleInvoiceDateChanges(value);
  };
  const handleInvoiceDateKeyDown = (e) => {
    let updatedTableArr = [...items];
    const zeroSalesIndex =
      updatedTableArr.findIndex((row) => row.itemCode.value === '') !== -1
        ? updatedTableArr.findIndex((row) => row.itemCode.value === '')
        : updatedTableArr.findIndex((row) => row.itemCode.value !== '');

    const element = 'itemCode' + zeroSalesIndex;
    const warMsg = invoiceLabels.dateName + ' is required';
    const name = 'invoiceDate';
    const currentId = 'invoiceDate';
    const nextId = companyType === 1 ? element : 'taxability';
    const prevID = data.currency.code === 'INR' ? 'currency' : 'currencyRate';
    const required = true;

    handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
  };
  const handleTaxabilityChange = (e, newValue) => {
    if (newValue === '') {
      setData((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          taxability: true,
        },
        errorFields: {
          ...prev.errorFields,
          taxability: 'Taxability is required',
        },
      }));
    } else {
      setData((prev) => ({
        ...prev,
        reverseChargeFlag: newValue.value === 4 ? 1 : 0,
      }));

      if (totNetAmt) {
        // let updatedItems = [...items];
        // updatedItems = updatedItems.map((ele) => ({
        //   ...ele,
        //   originalIGST: ele.originalIGST ?? ele.IGST,
        //   originalGSTCess: ele.originalGSTCess ?? ele.GSTCess,
        //   originalNetAmt: ele.originalNetAmt ?? ele.netAmount,
        //   originalTaxAmt: ele.originalTaxAmt ?? ele.taxableAMount,
        // }));

        // updatedItems = updatedItems.map((ele) => {
        //   if (newValue.value === 4 && (Type === 'Sales' || Type === 'Pos')) {
        //     let igstAmt = 0;
        //       if(ele?.manualGSTFlag===0){
        //     if(Number(ele.GSTRate)>0){
        //     igstAmt = (Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100;
        //     igstAmt = Number(igstAmt) / 2;
        //     igstAmt = Math.round(igstAmt * 100) / 100;
        //     igstAmt = igstAmt * 2;
        //     }
        //   }else{
        //     igstAmt=ele?.IGST;
        //   }
        //     return {
        //       ...ele,
        //       IGST: igstAmt,
        //       // ((Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100 / 2) *
        //       // 2,
        //       GSTCess: ele.originalGSTCess,
        //       netAmount: ele?.taxableAMount,
        //     };
        //   } else if ([2, 3, 5, 7, 9].includes(newValue.value)) {
        //     return {
        //       ...ele,
        //       IGST: 0,
        //       GSTCess: 0,
        //       netAmount: ele?.taxableAMount,
        //     };
        //   } else {
        //     let igstAmt = 0;
        //       if(ele?.manualGSTFlag===0){
        //      if(Number(ele.GSTRate)>0){
        //     igstAmt = (Number(ele.originalTaxAmt) * Number(ele.GSTRate)) / 100;
        //     igstAmt = Number(igstAmt) / 2;
        //     igstAmt = Math.round(igstAmt * 100) / 100;
        //     igstAmt = igstAmt * 2;
        //      }
        //     }else{
        //       igstAmt=ele?.IGST;
        //     }
        //     return {
        //       ...ele,
        //       IGST: igstAmt,
        //       // ((Number(ele.originalTaxAmt) * Number(ele.GSTRate)) / 100 / 2) *
        //       // 2,
        //       GSTCess: ele.originalGSTCess,
        //       taxableAMount: ele.originalTaxAmt,
        //       netAmount:
        //         Number(ele.originalTaxAmt) +
        //         Number(ele.originalGSTCess) +
        //         Number(
        //           igstAmt
        //           // ((Number(ele.originalTaxAmt) * Number(ele.GSTRate)) /
        //           //   100 /
        //           //   2) *
        //           //   2
        //         ),
        //     };
        //   }
        // });
         let updatedItems = [...items];

      updatedItems = updatedItems.map((ele) => ({
        ...ele,
        originalGSTRate: ele.GSTRate,
        originalCessRate: ele.cessRate,
        originalIGST: ele.IGST,
        originalGSTCess: ele.GSTCess,
        originalNetAmt: companyType === 3  ? ele.taxableAMount : ele.netAmount, //LEDX-4673
        originalTaxAmt: ele.taxableAMount,
      }));

      updatedItems = updatedItems.map((ele) => {
        if (newValue.value === 4) {
          let igstAmt = 0;
          
          if(ele?.manualGSTFlag===0){
          if(Number(ele.GSTRate)>0){
          igstAmt = (Number(ele.taxableAMount) * Number(ele.GSTRate)) / 100;
          igstAmt = Number(igstAmt) / 2;
          igstAmt = Math.round(igstAmt * 100) / 100;
          igstAmt = igstAmt * 2;
          }
        }else{
          igstAmt=ele?.IGST;
        }
         let cessAmt=0;
         if(ele?.manualCess===0){
          if(Number(ele.cessRate)>0){
          cessAmt = (Number(ele.taxableAMount) * Number(ele.cessRate)) / 100;
          cessAmt=Number(Number(cessAmt).toFixed(2));
        
          }
        }else{
          cessAmt=ele?.GSTCess;
           cessAmt=Number(Number(cessAmt).toFixed(2));
        }
          return {
            ...ele,
            IGST: igstAmt,
            // GSTCess: ele.originalGSTCess,
            GSTCess:cessAmt,//LEDX-5418
            netAmount: ele.taxableAMount,
          };
        } else if ([2, 3, 5, 7, 9].includes(newValue.value)) {
          return {
            ...ele,
            IGST: 0,
            GSTCess: 0,
            netAmount: ele.taxableAMount,
          };
        }
        
        else {
          let igstAmt = 0;
          if(ele?.manualGSTFlag===0){
          if(Number(ele.originalGSTRate)>0){
          igstAmt = (Number(ele.originalTaxAmt) * Number(ele.originalGSTRate)) / 100;
          igstAmt = Number(igstAmt) / 2;
          igstAmt = Math.round(igstAmt * 100) / 100;
          igstAmt = igstAmt * 2;
          }
        }else{
          igstAmt=ele?.IGST;
        }
         let cessAmt=0;
         if(ele?.manualCess===0){
          if(Number(ele.originalCessRate)>0){
          cessAmt = (Number(ele.originalTaxAmt) * Number(ele.originalCessRate)) / 100;
           cessAmt=Number(Number(cessAmt).toFixed(2));
        
          }
        }else{
           cessAmt=Number(Number(cessAmt).toFixed(2));
        }
          return {
            ...ele,
            IGST: igstAmt,
            GSTRate: ele.originalGSTRate,
            cessRate:ele.originalCessRate,
            // GSTCess: ele.originalGSTCess,
            GSTCess:cessAmt,//LEDX-5418
            taxableAMount: ele.originalTaxAmt,
            netAmount:
              //LEDX-4673
              companyType === 3 
                ? Number(ele.originalTaxAmt)
                : Number(ele.originalTaxAmt) +
                //  Number(ele.originalGSTCess) 
                Number(cessAmt)//LEDX-5418
                 + Number(igstAmt),
          };
        }
      });

        setItems(updatedItems);
      }
      if(Number(voucherFlag)!==-1){
        //  handleVoucherByTaxability(newValue?.value);
        if (data?.taxability?.value==="" ||
  ([2, 3, 5,7,9].includes(newValue?.value) !==
  [2, 3, 5,7,9].includes(Number(data?.taxability?.value)))
) {
  handleVoucherByTaxability(newValue?.value);
}

      }
      setData((prev) => ({
        ...prev,
        taxability: newValue,
        taxType:[2, 3, 5, 7, 9].includes(newValue?.value)|| Number(companyType)===3?3:1,
        errorStatus: {
          ...prev.errorStatus,
          taxability: false,
        },
        errorFields: {
          ...prev.errorFields,
          taxability: '',
        },
      }));
    }
  };
  //  function handleVoucherByTaxability(taxVal) {
  //   if (!activeVouchers?.length) return;
  
  //   const isSalesOrPos = Type === "Sales" || Type === "Pos";
   
  //   const preferByFlag = isSalesOrPos && [2, 3, 5].includes(taxVal);
  
  //   const toLabel = (v) => `${v?.prefix ?? ""}${v?.nextinvoicenumber ?? ""}${v?.suffix ?? ""}`;
  //   const pickedVoucher =
  //     (preferByFlag && activeVouchers.find((v) => v.serialflag === 1)) ||
  //     activeVouchers.find(v => v.secondlastused === 1) ||activeVouchers.find(v => v.lastused === 1)|| activeVouchers[0];
  
  //   const voucherNumber = pickedVoucher ? toLabel(pickedVoucher) : "";
  //   const selectedOption = pickedVoucher
  //     ? { label: voucherNumber, value: pickedVoucher.serialnumber }
  //     : { label: "", value: "" };
  
  //   setData((p) => ({ ...p, voucherNumber, seriesVouchers: selectedOption }));
  //   setInitialState?.((p) => ({ ...p, voucherNumber, seriesVouchers: selectedOption }));
  // }
   function handleVoucherByTaxability(taxVal) {
  if (!activeVouchers?.length) return;
const isSerialFlag=data?.seriesVouchers?.serialflag;
  const isSalesOrPos = Type === "Sales" || Type === "Pos";
 
  const preferByFlag = isSalesOrPos && [2, 3, 5,7,9].includes(taxVal);

  const toLabel = (v) => `${v?.prefix ?? ""}${v?.nextinvoicenumber ?? ""}${v?.suffix ?? ""}`;
  // const pickedVoucher =
  //   (preferByFlag && activeVouchers.find((v) => v.serialflag === 1)) ||
  //    activeVouchers.find(v => v.secondlastused === 1) ||activeVouchers.find(v => v.lastused === 1)|| activeVouchers[0];
    
    const pickedVoucher =
    // (preferByFlag && activeVouchers.find((v) => v.serialflag === 1))
    (preferByFlag ? activeVouchers.find((v) => v.serialflag === 1):(activeVouchers.find((v) => v.serialflag === 0))) ||(
    (activeVouchers.find((v) => v.serialflag === 1 && v.lastused===1)? activeVouchers.find(v => v.secondlastused === 1):activeVouchers.find(v => v.lastused === 1)) ||activeVouchers.find(v => v.lastused === 1)|| activeVouchers[0]);

  const voucherNumber =!params?.id?(pickedVoucher ? toLabel(pickedVoucher) : ""):(preferByFlag ? toLabel(pickedVoucher):invoiceEntry?.invoicenumber);
  const selectedOption =!params?.id?(pickedVoucher
    ? { label: voucherNumber, value: pickedVoucher.serialnumber,serialflag:pickedVoucher.serialflag }
    : { label: "", value: "",serialflag:0 }):(preferByFlag?
     { label: voucherNumber, value: pickedVoucher.serialnumber,serialflag:pickedVoucher.serialflag }:{ label: voucherNumber, value: invoiceEntry.serialnumber,serialflag:invoiceEntry.serialflag });
  if(Number(isSerialFlag)===Number(pickedVoucher.serialflag)){
    return;
  }
  setData((p) => ({ ...p, voucherNumber, seriesVouchers: selectedOption }));
  setInitialState?.((p) => ({ ...p, voucherNumber, seriesVouchers: selectedOption }));
}
  const handleTaxabilityKeyDown = (e) => {
    let updatedTableArr = [...items];
    const zeroSalesIndex =
      updatedTableArr.findIndex((row) => row.itemCode.value === '') !== -1
        ? updatedTableArr.findIndex((row) => row.itemCode.value === '')
        : updatedTableArr.findIndex((row) => row.itemCode.value !== '');

    const element = 'itemCode' + zeroSalesIndex;
    const warMsg = '';
    const name = 'taxability';
    const currentId = 'taxability';
    const nextId = element;
    const prevID = 'invoiceDate';
    const required = true;

    handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
  };

  async function getPosPartiesDetails(number) {
    let posPartyArr = [];
    let filterPosArr = [];
    try {
      const res = await API.graphql(graphqlOperation(getpospartydetails, { phonenumber: number }));
      if (res?.data?.getpospartydetails?.length > 0) {
        res?.data?.getpospartydetails?.map((ele) => {
          posPartyArr.push({
            label: ele?.phonenumber,
            value: ele.pospartyid,
            partyName: ele.partyname,
          });
        });
        posPartyArr.map((ele) => {
          if (ele.label !== '') {
            filterPosArr.push(ele);
          }
        });
        setPosParties(filterPosArr);
      }
    } catch (err) {
      console.log('err', err);
    }
  }
  function getInvoiceBasicDetails(invoiceEntry) {
    // setBackdropOpen(true);
    let invID = '';
    let voucherNumber = '';
    let invDate = '';
    let taxType = { label: '', value: '',serialflag:0 };
     let seriesVouchers={label:"",value:""};
      if(invoiceEntry?.serialnumber===""){
        setGeneralSettingsFlag(-1);
     }else{
      setGeneralSettingsFlag("");
     }
    if (Type === 'Sales' || Type === 'Pos') {
       if(invoiceEntry?.serialnumber===""){
            voucherNumber = invoiceEntry?.invoicenumber;
            }else{
              seriesVouchers={label:invoiceEntry?.invoicenumber,value:invoiceEntry?.serialnumber,serialflag:invoiceEntry?.serialflag};
            }
      invID = invoiceEntry?.invoiceid;
      voucherNumber = invoiceEntry?.invoicenumber;
      invDate = invoiceEntry?.invoicedate;
    }
    const formatDate = (dateString) => {
      const date = new Date(Number(dateString) * 1000);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };
    if (invoiceEntry?.length !== 0) {
      let billingCurrency = { label: '', value: '', sign: '', code: '' };
      billingCurrencyOptions.map((ele) => {
        if (ele.value === invoiceEntry?.currencycode) {
          billingCurrency = {
            label: ele.label,
            value: ele.value,
            sign: ele.sign,
            code: ele.code,
          };
        }
      });

      if (invoiceEntry?.relatedinvoiceposdetails.length > 0) {
        setData((prev) => ({
          ...prev,
          partyName: invoiceEntry?.relatedinvoiceposdetails?.[0]?.relatedposparty?.[0]?.partyname,
          partyContactNumber: invoiceEntry?.relatedinvoiceposdetails?.[0]?.relatedposparty?.[0]?.relatedphonecontacts?.[0]?.phonenumber,
        }));
        if (setInitialState)
          setInitialState((prev) => ({
            ...prev,
            partyName: invoiceEntry?.relatedinvoiceposdetails?.[0]?.relatedposparty?.[0]?.partyname,
            partyContactNumber: invoiceEntry?.relatedinvoiceposdetails?.[0]?.relatedposparty?.[0]?.relatedphonecontacts?.[0]?.phonenumber,
          }));
      }
      const invoiceDate = formatDate(invDate);
      allTaxabilityOptions.map((ele) => {
        if (ele.value == invoiceEntry?.invoicetaxabletypecd) taxType = { label: ele?.label, value: ele?.value };
      });
      setData((prev) => ({
        ...prev,
        voucherNumber: voucherNumber,
         seriesVouchers:seriesVouchers,
        invoiceDate: invoiceDate,
        currency: billingCurrency,
        currencyRate: invoiceEntry?.currencyrate,
        partyCategory: 'PosParty',
        reverseChargeFlag: invoiceEntry?.reversechargeflag,
        taxability: taxType,
        taxType:invoiceEntry?.taxability,
        
      }));
      if (setInitialState)
        setInitialState((prev) => ({
          ...prev,
          voucherNumber: voucherNumber,
           seriesVouchers:seriesVouchers,
          invoiceDate: invoiceDate,
          currency: billingCurrency,
          currencyRate: invoiceEntry?.currencyrate,
          partyCategory: 'PosParty',
          taxability: taxType,
          taxType:invoiceEntry?.taxability,
        }));
      setPartyType('CUSTOMER');
    }
    // setBackdropOpen(false);
  }
  const userPreferenceAndFY = useSelector((state) => state.userPrefrenceandReducer);
  async function listUserPreferenceData() {
    try {
      // const res = await API.graphql(graphqlOperation(listUserPreference));
      let attributeValue = '';
      let bankAttributeValue = '';
      // res?.data?.listUserPreference?.map((ele) => {
      userPreferenceAndFY.userPreference?.map((ele) => {
        if (ele.attributetypecd === 'SelectedFinYear') {
          attributeValue = ele.attributevalue;
        }
        if (ele.attributetypecd === 'SelectedBankDetails') {
          bankAttributeValue = ele.attributevalue;
        }
      });
      getFY(userPreferenceAndFY?.financialYear?.financialyearid);
    } catch (error) {
      console.log('error', error);
    }
  }

  async function getFY(data) {
    try {
      setStartDate(userPreferenceAndFY.financialYear.startdate);
      setEndDate(userPreferenceAndFY.financialYear.enddate);
    } catch (error) {
      console.log('Error', error);
    }
  }
  async function getCurrentCurrencyRate(code) {
    try {
      const response = await axios.get(`https://api.exchangerate-api.com/v4/latest/${code}`);
      if (response.data.rates.INR !== null) {
        setData((prev) => ({
          ...prev,
          currencyRate: Number(response.data.rates.INR).toFixed(2),
        }));
        if (setInitialState)
          setInitialState((prev) => ({
            ...prev,
            currencyRate: Number(response.data.rates.INR).toFixed(2),
          }));
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  useEffect(() => {
    getCompanyDetails();
    listUserPreferenceData();
    // listPosPartyDetails();
  }, []);
  useEffect(() => {
    if (invoiceEntry?.length !== 0) {
      getInvoiceBasicDetails(invoiceEntry);
    }
  }, [invoiceEntry]);
  function handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
      if (required && e.target.value === '') {
        e.preventDefault();
        e.stopPropagation();
        setData((prev) => ({
          ...prev,
          [name]: '',
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: warMsg,
          },
        }));
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  function handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID, multiple) {
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';

    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
      if (multiple && e.key === 'Enter') {
        return; // Exit without moving focus to next field
      }

      if (
        required &&
        (e.target.value === '' || e.target.value === undefined || e.target.value === 0) &&
        isAutocompleteOpen &&
        !activeDescendantId
      ) {
        e.preventDefault();
        e.stopPropagation();
        setData((prev) => ({
          ...prev,
          [name]: '',
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: warMsg,
          },
        }));
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }

  useEffect(() => {
    const element = document.getElementById('autocomplete');
    if (element) {
      element.focus();
    }
  }, []);

  function handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID, momentInvoiceDate, invoiceLabels) {
    const minDate = moment(
      params?.id && !isNaN(params.id)
        ? firstInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD')
        : lastInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    const maxDate = moment(
      params?.id && !isNaN(params.id)
        ? nextInvoiceDate || moment(endDate * 1000).format('YYYY-MM-DD')
        : moment(endDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    if (e.key === 'Tab' && e.shiftKey) {
      document.getElementById(prevID)?.focus();
      return;
    }

    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
      if (
        name === 'invoiceDate' &&
        (moment(e?.target?.value, 'YYYY-MM-DD').isBefore(minDate) || moment(e?.target?.value, 'YYYY-MM-DD').isAfter(maxDate))
      ) {
        console.log('dateC', currentId);

        e?.preventDefault();
        e?.stopPropagation();
        document.getElementById(currentId)?.focus();
        return;
      } else {
        e?.preventDefault();
        e?.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  function handleInvoiceDateChanges(value) {
    const updatedTableArr = [...items];
    let isValid = true;
    const minDate = moment(
      params?.id && !isNaN(params.id)
        ? firstInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD')
        : Type === 'DebitNote' || Type === 'Purchase' || Type === 'CreditNote'
        ? firstInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD')
        : lastInvoiceDate || moment(startDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    const maxDate = moment(
      params?.id && !isNaN(params.id)
        ? nextInvoiceDate || moment(endDate * 1000).format('YYYY-MM-DD')
        : moment(endDate * 1000).format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    );

    // const minDate = moment(
    //   params?.id && !isNaN(params.id)
    //     ? firstInvoiceDate || moment(startDate * 1000).format("YYYY-MM-DD")
    //     : lastInvoiceDate || moment(startDate * 1000).format("YYYY-MM-DD"),
    //   "YYYY-MM-DD"
    // );

    // const maxDate = moment(
    //   params?.id && !isNaN(params.id)
    //     ? nextInvoiceDate || moment(endDate * 1000).format("YYYY-MM-DD")
    //     : moment(endDate * 1000).format("YYYY-MM-DD"),
    //   "YYYY-MM-DD"
    // );

    if (value === '') {
      setData((prev) => ({
        ...prev,
        invoiceDate: value,
        errorStatus: {
          ...prev.errorStatus,
          invoiceDate: true,
        },
        errorFields: {
          ...prev.errorFields,
          invoiceDate: `${invoiceLabels.dateName} is required`,
        },
      }));
      return;
    }

    const momentInvoiceDate = moment(value, 'YYYY-MM-DD');

    // Check if invoiceDate is within the allowed range
    if (momentInvoiceDate.isBefore(minDate) || momentInvoiceDate.isAfter(maxDate)) {
      setData((prev) => ({
        ...prev,
        invoiceDate: value,
        errorStatus: {
          ...prev.errorStatus,
          invoiceDate: true,
        },
        errorFields: {
          ...prev.errorFields,
          invoiceDate: `${invoiceLabels.dateName} must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format('DD MMM YYYY')}.`,
        },
      }));
      return;
    }

    // updatedTableArr.forEach((subele) => {
    //   if (subele?.effectiveFrom !== 0) {
    //     let tempEffectiveFrom = moment(subele.effectiveFrom * 1000, "X");
    //     let tempEffectiveTo =
    //       subele.effectiveTo === "" || subele?.effectiveTo === 0
    //         ? null
    //         : moment(subele.effectiveTo * 1000, "X");

    //     if (
    //       tempEffectiveFrom.isAfter(momentInvoiceDate) ||
    //       (tempEffectiveTo && tempEffectiveTo.isBefore(momentInvoiceDate))
    //     ) {
    //       isValid = false;
    //       subele.invalidDate = true;
    //     }
    //   }
    // });

    // if (!isValid) {
    //   showWarningSnackbar(
    //     "The highlighted items do not match the invoice date range. Please verify the effective dates."
    //   );
    //   return;
    // }
    checkPriceTypeWithInvDate(value);

    let dueDate = moment(value).add(data?.creditPeriod, 'days').format('DD MMM YYYY');

    setData((prev) => ({
      ...prev,
      invoiceDate: value,
      dueDate: dueDate,
      customerOrderDate: value,
      errorStatus: {
        ...prev.errorStatus,
        invoiceDate: false,
        dueDate: false,
      },
      errorFields: {
        ...prev.errorFields,
        invoiceDate: '',
        dueDate: '',
      },
    }));
  }
  function checkPriceTypeWithInvDate(value) {
    const updatedTableArr = [...items];
    let isValid = true;

    const momentInvoiceDate = moment(value, 'YYYY-MM-DD');
    updatedTableArr.forEach((subele) => {
      if (subele?.effectiveFrom !== 0) {
        const tempEffectiveFrom = moment(subele.effectiveFrom * 1000).startOf('day');
        const tempEffectiveTo =
          subele.effectiveTo === '' || subele?.effectiveTo === 0 ? null : moment(subele.effectiveTo * 1000).startOf('day');

        const normalizedInvoiceDate = moment(momentInvoiceDate).startOf('day');
        const isOutsideRange =
          normalizedInvoiceDate.isBefore(tempEffectiveFrom) || (tempEffectiveTo && normalizedInvoiceDate.isAfter(tempEffectiveTo));

        if (isOutsideRange) {
          isValid = false;
          subele.invalidDate = true;
        } else {
          subele.invalidDate = false;
        }
      }
    });

    if (!isValid) {
      showWarningSnackbar('The highlighted items do not match the invoice date range. Please verify the effective dates.');
    }
  }
  return (
    <Box className={params?.view === true ? 'disable-interactions !mportant' : ''}>
      <Box
        sx={{
          m: 1,
          marginLeft: '0px',
          display: 'flex',
          alignItems: { sm: 'center' },
          flexWrap: { xs: 'wrap', md: 'nowrap' },
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        <Grid container spacing={2}>
          <Grid item lg={2} xs={12}>
            <Autocomplete
              clear
              freeSolo
              options={posParties}
              size="small"
              id="partyContactNumber"
              disableClearable
              forcePopupIcon={false}
              noOptionsText=""
              getOptionLabel={(option) => (option?.label ? option?.label : data.partyContactNumber)}
              value={data.partyContactNumber}
              isOptionEqualToValue={(option, value) => option.label === value}
              renderOption={(props, option) => (
                <li {...props} key={option?.value} value={option?.label}>
                  {option.label}
                </li>
              )}
              onChange={handlePartyNumberChange}
              onInputChange={handlePartyInputChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={data.errorStatus.partyContactNumber === true ? true : false}
                  label="Party Contact Number"
                  id="partyContactNumber"
                  value={data.partyContactNumber}
                  onChange={handleTextPartyNumberChange}
                  fullWidth
                  size="small"
                  sx={{
                    'MuiFormLabel-asterisk': {
                      color: 'danger.main',
                    },
                  }}
                   inputProps={{ inputMode: "numeric", maxLength: 15, pattern: "[0-9]*" }}
  onKeyDown={(e) => {
    if (
      ["e","E","+","-","."," "].includes(e.key) ||
      (isNaN(Number(e.key)) &&
        !["Backspace","Delete","ArrowLeft","ArrowRight","Tab"].includes(e.key))
    ) e.preventDefault();
  }}
                />
              )}
              PaperComponent={(props) => {
                if (
                  data?.partyContactNumber?.length > 2 &&
                  posParties?.length > 0 &&
                  posParties?.some((option) => option?.label?.includes(data?.partyContactNumber))
                ) {
                  return <Paper {...props}>{props.children}</Paper>;
                }
              }}
            />
            <Typography
              sx={{
                marginTop: '2px',
                marginLeft: '10px',
                marginBottom: '0px',
                fontSize: '11px',
                color: 'danger.main',
              }}
            >
              {data?.errorFields.partyContactNumber}
            </Typography>
          </Grid>
          <Grid item lg={3} xs={12}>
            <TextField
              name="partyName"
              id="partyName"
              value={data.partyName}
              size="small"
              fullWidth
              label="Party Name"
              onChange={handlePartyNameChange}
            />
          </Grid>

          <VoucherComponent
            data={data}
            setData={setData}
            setInitialState={setInitialState}
            invoiceLabels={invoiceLabels}
            todayDate={todayDate}
            voucherArr={voucherArr}
            setVoucherArr={setVoucherArr}
            params={params}
            Type={Type}
            invoiceEntry={invoiceEntry}
            companyData={companyData}
            next={data?.partyName === '' || invoiceEntry?.length !== 0 ? 'invoiceDate' : 'currency'}
          />
          <Grid item lg={2} xs={12}>
            <Autocomplete
              disablePortal
              disabled={data?.partyName === '' || invoiceEntry?.length !== 0 ? true : false}
              id="currency"
              options={billingCurrencyOptions}
              disableClearable
              value={data.currency}
              isOptionEqualToValue={(option, value) => option?.value === value?.value}
              onChange={handleCurrencyChange}
              size="small"
              renderInput={(params) => (
                <TextField
                  required={data.currency.value === '' ? true : false}
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '16px',
                      fontWeight: 'bold',
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...params}
                  label="Billing Currency"
                />
              )}
            />
            <Typography
              sx={{
                marginTop: '2px',
                marginLeft: '10px',
                marginBottom: '0px',
                fontSize: '11px',
                color: 'danger.main',
              }}
            >
              {data?.errorFields.seriesVouchers}
            </Typography>
          </Grid>
          {data.currency.code !== 'INR' && (
            <Grid item lg={1.5} xs={12} md={12}>
              <TextField
                error={data.errorStatus.currencyRate === true ? true : false}
                label="Currency Rate"
                size="small"
                name="currencyRate"
                id="currencyRate"
                required={data.currencyRate === '' || data.currencyRate === 0 ? true : false}
                value={data.currencyRate}
                type="text"
                onChange={handleCurrencyRateChange}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  maxWidth: 180,
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CurrencyRupeeIcon fontSize="14px" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          )}
          <Grid item lg={1.5} xs={12}>
            <TextField
              error={data.errorStatus.invoiceDate === true}
              disabled={data?.partyName?.value === ''}
              name="invoiceDate"
              id="invoiceDate"
              label={invoiceLabels.dateName}
              variant="outlined"
              inputProps={{
                min: fromDayDate,
                max: endDayDate,
              }}
              size="small"
              type="date"
              value={data.invoiceDate}
              onChange={handleInvoiceDateChange} // Separated onChange function
              onKeyDown={handleInvoiceDateKeyDown}
              InputProps={{
                inputProps: {
                  min:
                    params?.id && !isNaN(params.id)
                      ? firstInvoiceDate || (startDate && moment(startDate).isValid()? moment(startDate * 1000).format('YYYY-MM-DD'):"")
                      : lastInvoiceDate || (startDate && moment(startDate).isValid()? moment(startDate * 1000).format('YYYY-MM-DD'):""),
                  max:
                    params?.id && !isNaN(params.id)
                      ? nextInvoiceDate || moment(endDate * 1000).format('YYYY-MM-DD')
                      : moment(endDate * 1000).format('YYYY-MM-DD'),
                },
                endAdornment: <LabelIcon value={data.invoiceDate} type="text" editMode={false} />,
              }}
              fullWidth
              sx={{
                '.MuiFormLabel-asterisk': {
                  color: 'danger.main',
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography
              sx={{
                marginTop: '2px',
                marginLeft: '10px',
                marginBottom: '0px',
                fontSize: '11px',
                color: 'danger.main',
              }}
            >
              {data?.errorFields.invoiceDate}
            </Typography>
          </Grid>
          {companyType != 1 && (
            <>
              <Grid item lg={1.5} xs={12}>
                <Autocomplete
                  size="small"
                  fullWidth
                  openOnFocus
                  autoFocus
                  disableClearable
                  id="taxability"
                  name="taxability"
                  options={companyType == 3 ? compositeTaxabilityForCustomer : taxabilityOptions}
                    getOptionDisabled={(option) => {
                       if (Number(companyType) === 3) {
                    return;
                  }
  const allowed =[2, 3, 5, 7, 9];
  const flag = data?.seriesVouchers?.serialflag === 1;

  
  if (Type === 'Pos' && generalSettingsFlag !== -1) {
    return flag
      ? !allowed.includes(option.value)   
      : allowed.includes(option.value);   
  }
  return false;
}}
                  value={data?.taxability}
                  isOptionEqualToValue={(option, value) => option?.value === value?.value}
                  disabled={data?.partyName?.value === '' ? true : false}
                  onChange={handleTaxabilityChange} // Separated onChange function
                  onKeyDown={handleTaxabilityKeyDown}
                  renderInput={(params) => (
                    <TextField
                      error={data.errorStatus.taxability == true ? true : false}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      {...params}
                      label="Taxability"
                      required={true}
                    />
                  )}
                />
                <Typography
                  sx={{
                    marginTop: '2px',
                    marginLeft: '10px',
                    marginBottom: '0px',
                    fontSize: '11px',
                    color: 'danger.main',
                  }}
                >
                  {data?.errorFields.taxability}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
      {(data?.taxability?.value == 2 || data?.taxability?.value == 3 || data?.taxability?.value == 5) &&
        !params?.id &&
        companyType !== 3 && (
          <Typography sx={{ color: 'red', m: 2, fontSize: '12px', maxWidth: '1000px' }}>
            *Note: If the supply is Exempted, Non-GST, or Out of Scope, the document will be treated as a Bill of Supply instead of a Tax
            Invoice.
          </Typography>
        )}
    </Box>
  );
}

export default InvoicePosBasicDetails;
